import BarChart, { BarChartData } from "@/components/visualizations/BarChart/BarChart";
import useTranslation from "@/hooks/useTranslation";
import { useFacilityImpactPerType } from "@/pages/dashboard/hooks/useFacilityImpact";
import Widget from "../../components/Widget/Widget";
import { ImpactMetric } from "../../utils/types";
import { facilityLabel } from "./FacilityImpactTopContributors";

export default function FacilityImpactPerType({ metric }: { metric: ImpactMetric }) {
  const { data, isLoading, isFetching } = useFacilityImpactPerType({ metric: metric.key });
  const translation = useTranslation();

  const chartData: BarChartData = data
    ? [
        {
          label: metric.label,
          data: data.map((row) => ({
            label: facilityLabel(row.name),
            value: row.impact[metric.key],
          })),
        },
      ]
    : [];

  return (
    <Widget
      title={"Facility impact per resource type"}
      tooltip={translation["dashboard"]["facility"]["per_energy_type"]}
    >
      <BarChart
        data={chartData}
        format={metric.formatter}
        loading={isLoading || isFetching}
        orientation={"horizontal"}
        colorPalette={"light_blue"}
        showLegend={false}
        xAxisTitle={`${metric.label} (${metric.unit})`}
      />
    </Widget>
  );
}
